import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { getHiddenSpace } from '../../utils/getHiddenSpace';
import { spaceFactory } from '../../utils/spaceFactory';
import { Normative026 } from '../../../generated/graphql';

// TODO: monkeypatch o algo que me permita agregar info al space para saber que vino de esta función
export const getSpaceBancoDeBogota: GetSpaceBase = (group, space, context) => {
  const { negBooleans, alternative, outDebt: { extra: outDebtExtra } = {}, option } = context;
  const {
    isTotalPayment,
    isInstallmentsPlan,
    isBalanceBehindPayment,
    isBogotaNoPayment,
    isPrepaymentCompleted,
    isApprovedByBank,
    isRefinance,
    isPaymentPromise,
    isBogotaTraditional: isTraditional,
    isBogotaPrepaymentWeightedRate: isPrepaymentWeightedRate,
    isBogotaPrepaymentPreferentialRate: isPrepaymentPreferentialRate,
    isBogotaTermExtension,
    isBogotaTermExtensionDiscountInterest,
    isBogotaTermExtensionDiscountInterestLowRate,
    isBogotaLowRate,
    isBogotaSpecialCampaign,
    isBogotaSpecialCampaignLowRate,
    isPrepaymentCompletedOrAfter,
    isSentToBank,
    isRejected,
    isExpired,
    isPrepaymentIncompleted,
  } = negBooleans!;
  const { normative026 } = outDebtExtra || {};
  const { prePayment } = alternative || {};
  const isDocumentalTermExtension = option?.settings?.isDocumentalTermExtension;

  const termExtensionEffectiveAnnualRate = `${(
    (alternative?.effectiveAnnualRate || 0) * 100
  ).toFixed(2)}%`;
  const termExtensionDiscountPercent = `${((alternative?.discountPercent || 0) * 100).toFixed(2)}%`;
  const termExtensionDiscountMora = `${((alternative?.discountMora || 0) * 100).toFixed(0)}%`;
  const campaignEffectiveAnnualRate = `${((alternative?.effectiveAnnualRate || 0) * 100).toFixed(2)}%`;

  const hasPrePayment = Boolean(prePayment);

  switch (group) {
    case 'NEG_OPTION_TERMS': {
      switch (space) {
        case 'title': {
          if (isBogotaNoPayment || isBogotaLowRate) return spaceFactory('', false).get();
          let key = 'NEG_OPTION_TERMS__title.nuevosterminos'; // default
          if (isBalanceBehindPayment) key = 'NEG_OPTION_TERMS__title.acuerdo';
          if (isTotalPayment || isInstallmentsPlan || isBogotaTermExtension) key = 'NEG_OPTION_TERMS__title.acuerdopago';
          return spaceFactory(key).get();
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'benefits.title': {
          return spaceFactory('NEG_OPTION_CONDITIONS__benefits.title').get();
        }
        case 'benefits.text': {
          if (isTotalPayment) return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.totalPayment').get();
          if (isInstallmentsPlan) return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.installmentsPlan').get();
          if (isBogotaSpecialCampaignLowRate) {
            return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.balanceBehindPayment.specialCampaignLowRate')
              .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
          }
          if (isBogotaSpecialCampaign) {
            return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.balanceBehindPayment.specialCampaign').get();
          }
          if (isBogotaTermExtension) {
            if (isBogotaTermExtensionDiscountInterestLowRate) return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.termExtension.discountInterestLowRate').get({ effectiveAnnualRate: termExtensionEffectiveAnnualRate });
            return spaceFactory('NEG_OPTION_CONDITIONS__benefits.text.termExtension').get();
          }
          break;
        }
        case 'consequences.text': {
          if (isTotalPayment) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.totalPayment').get();
          if (isInstallmentsPlan) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.installmentsPlan').get();
          if (isRefinance) {
            if (normative026 === Normative026.Restructuring) {
              if (hasPrePayment) {
                return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.restructuring.prePayment').get();
              }
              return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.restructuring.noPrePayment').get();
            }
            if (normative026 === Normative026.Modification) {
              if (hasPrePayment) {
                return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.modification.prePayment').get();
              }
              return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.modification.noPrePayment').get();
            }
            // Default cases when normative026 is not provided or is an unhandled value
            if (hasPrePayment) {
              return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.prePayment').get();
            }
            return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.refinance.noPrePayment').get();
          }
          if (isBalanceBehindPayment) {
            if (isBogotaSpecialCampaignLowRate) {
              return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.balanceBehindPayment.specialCampaignLowRate')
                .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
            }
            if (isBogotaSpecialCampaign) {
              return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.balanceBehindPayment.specialCampaign').get();
            }
            if (isBogotaNoPayment) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.balanceBehindPayment.noPayment').get();
            if (isBogotaLowRate) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.balanceBehindPayment.low_rate').get();
            return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.balanceBehindPayment').get();
          }
          if (isPaymentPromise) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.paymentPromise').get();
          if (isBogotaTermExtension) {
            if (isDocumentalTermExtension) return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.termExtension.documental').get();
            return spaceFactory('NEG_OPTION_CONDITIONS__consequences.text.termExtension').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_SUMMARY': {
      switch (space) {
        case 'description': {
          if (isInstallmentsPlan) return spaceFactory('NEG_OPTION_SUMMARY__description.installmentsPlan').get();
          if (isBogotaTermExtension) return spaceFactory('NEG_OPTION_SUMMARY__description.termExtension').get();
          return spaceFactory('NEG_OPTION_SUMMARY__description').get();
        }
        case 'alert.conditions': {
          if (isTotalPayment) return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.totalPayment').get();
          if (isInstallmentsPlan) return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.installmentsPlan').get();
          if (isBogotaTermExtension) {
            if (isDocumentalTermExtension) return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.termExtension.documental').get();
            return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.termExtension').get();
          }
          if (isRefinance) {
            if (!hasPrePayment) return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.refinance.noPrepayment').get();
            return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.refinance').get();
          }
          if (isBogotaSpecialCampaignLowRate) {
            return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.balanceBehindPayment.specialCampaignLowRate')
              .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
          }
          if (isBogotaSpecialCampaign) {
            return spaceFactory('NEG_OPTION_SUMMARY__alert.conditions.balanceBehindPayment.specialCampaign').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION': {
      switch (space) {
        case 'title': {
          if (isBogotaSpecialCampaignLowRate) {
            return spaceFactory('NEG_OPTION__title.balanceBehindPayment.specialCampaignLowRate').get();
          }
          if (isBogotaSpecialCampaign) {
            return spaceFactory('NEG_OPTION__title.balanceBehindPayment.specialCampaign').get();
          }
          break;
        }
        case 'description': {
          if (isRefinance
            && (isTraditional || isPrepaymentWeightedRate || isPrepaymentPreferentialRate)) {
            return spaceFactory('NEG_OPTION__description.novacion_tradicional').get();
          }
          if (isTotalPayment) return spaceFactory('NEG_OPTION__description.totalPayment').get();
          if (isInstallmentsPlan) return spaceFactory('NEG_OPTION__description.installmentsPlan').get();
          if (isBogotaSpecialCampaignLowRate) {
            return spaceFactory('NEG_OPTION__description.balanceBehindPayment.specialCampaignLowRate')
              .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
          }
          if (isBogotaSpecialCampaign) {
            return spaceFactory('NEG_OPTION__description.balanceBehindPayment.specialCampaign').get();
          }
          if (isBogotaTermExtension) {
            if (isBogotaTermExtensionDiscountInterestLowRate) return spaceFactory('NEG_OPTION__description.termExtension.discountInterestLowRate').get({ effectiveAnnualRate: termExtensionEffectiveAnnualRate, discountPercent: termExtensionDiscountPercent, discountMora: termExtensionDiscountMora });
            if (isBogotaTermExtensionDiscountInterest) return spaceFactory('NEG_OPTION__description.termExtension.discountInterest').get({ discountPercent: termExtensionDiscountPercent, discountMora: termExtensionDiscountMora });
            return spaceFactory('NEG_OPTION__description.termExtension').get();
          }
          break;
        }
        case 'state.alert': {
          if (isTotalPayment) {
            if (isPrepaymentCompleted) return spaceFactory('NEG_OPTION__state.alert.totalPayment.prepaymentCompleted').get();
            if (isApprovedByBank) return spaceFactory('NEG_OPTION__state.alert.totalPayment.isApprovedByBank').get();
          }
          if (isBogotaTermExtension) {
            if (isPrepaymentCompleted) return spaceFactory('NEG_OPTION__state.alert.termExtension.prepaymentCompleted').get();
            if (isApprovedByBank) return spaceFactory('NEG_OPTION__state.alert.termExtension.isApprovedByBank').get();
          }
          if (isBalanceBehindPayment && isBogotaNoPayment) {
            if (isApprovedByBank) return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.noPayment.isApprovedByBank').get();
            return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.noPayment').get();
          }
          if (isBalanceBehindPayment && isBogotaSpecialCampaign) {
            if (isRejected || isExpired || isPrepaymentIncompleted) return getHiddenSpace();
            if (isBogotaSpecialCampaignLowRate) {
              if (isApprovedByBank) {
                return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaignLowRate.approvedByBank')
                  .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
              }
              if (isPrepaymentCompletedOrAfter || isSentToBank) {
                return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaignLowRate.sentToBank')
                  .get({ effectiveAnnualRate: campaignEffectiveAnnualRate });
              }
              return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaignLowRate').get({
                effectiveAnnualRate: campaignEffectiveAnnualRate,
              });
            }
            if (isApprovedByBank) {
              return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaign.approvedByBank').get();
            }
            if (isPrepaymentCompletedOrAfter || isSentToBank) {
              return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaign.sentToBank').get();
            }
            return spaceFactory('NEG_OPTION__state.alert.balanceBehindPayment.specialCampaign').get();
          }
          return getHiddenSpace();
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
